<template>
  <v-app>

    <!--core-filter /-->

    <core-drawer/>
    <core-toolbar />

    <v-main>
    
      <v-container v-if='announcement' class="pa-0 ma-0" style="max-width:2000px">
        <v-alert dismissible class="ma-6 mb-0" outlined type='error'>{{announcement}}</v-alert>
      </v-container>

      <div id="core-view">
        <v-fade-transition mode="out-in">
          <slot/>
        </v-fade-transition>
      </div>
     
    </v-main>

    <core-snackbar/>
    <!-- <core-loader /> -->
    <core-confirm ref="confirm" />

    <app-change-password-modal />

    <core-footer />
  </v-app>
</template>
<script>
import { mapState } from 'vuex'
export default {
  mounted () {
    this.$root.$confirm = this.$refs.confirm
  },
  computed: mapState('app', ['announcement'])
}
</script>
<style lang="scss">
@import '@/styles/index.scss';

.theme--light.v-application {
  background-color: rgb(230, 230, 230);
}

/* Remove in 1.2 */
// .v-datatable thead th.column.sortable i {
//   vertical-align: unset;
// }
</style>
